import { useState } from 'react'

/**
 * True from the first time `isOpen` is true on. Lets a lazily loaded dialog
 * or panel stay out of the bundle until it is first needed, then stay
 * mounted (keeping its close animation and state) like an eager one.
 *
 * @param {boolean} isOpen
 * @returns {boolean}
 */
export function useHasOpened(isOpen) {
  const [hasOpened, setHasOpened] = useState(Boolean(isOpen))
  if (isOpen && !hasOpened) setHasOpened(true)
  return hasOpened || Boolean(isOpen)
}
